import React from 'react';
import DealsStatsGrid from '@/modules/deals/components/shared/DealsStatsGrid';
import { PROPOSAL_STATS_CONFIG } from '@/modules/deals/utils';

const ProposalStats = ({ stats, activeMetric, onMetricClick }) => {
  return (
    <DealsStatsGrid
      items={PROPOSAL_STATS_CONFIG}
      stats={stats}
      activeMetric={activeMetric}
      onMetricClick={onMetricClick}
    />
  );
};

export default ProposalStats;
